import { render, staticRenderFns } from "./ContDatasourcesAssignment.vue?vue&type=template&id=f79a5642&lang=pug"
import script from "./ContDatasourcesAssignment.vue?vue&type=script&lang=js"
export * from "./ContDatasourcesAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79a5642')) {
      api.createRecord('f79a5642', component.options)
    } else {
      api.reload('f79a5642', component.options)
    }
    module.hot.accept("./ContDatasourcesAssignment.vue?vue&type=template&id=f79a5642&lang=pug", function () {
      api.rerender('f79a5642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContDatasourcesAssignment.vue"
export default component.exports